import React, { useCallback } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@material-ui/core";
import { useRouter } from "next/router";
import { useTheme } from "@material-ui/core/styles";

interface IProps {
    open: boolean;
    handleClose: () => void;
    title: string;
    contentText: string;
    closeButtonText: string;
    redirectUrlOnClose?: string;
}

const ModalAlert = ({
    open,
    handleClose,
    title,
    contentText,
    closeButtonText,
    redirectUrlOnClose,
}: IProps) => {
    const router = useRouter();
    const theme = useTheme();

    const handleClickClose = useCallback(() => {
        handleClose();
        if (open && redirectUrlOnClose) {
            router.push(redirectUrlOnClose);
        }
    }, [open, redirectUrlOnClose, handleClose, router]);

    return (
        <Dialog
            open={open}
            onClose={handleClickClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                id="alert-dialog-title"
                style={{
                    backgroundColor: theme?.palette?.primary?.main || "#bababa",
                    color: theme?.palette?.primary?.contrastText || "black",
                }}
            >
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {contentText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClickClose}
                    color="secondary"
                    variant="contained"
                >
                    {closeButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalAlert;
